import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import type { PeriodBusinessView } from '../../../../models/api.models';

type ProductEconomicsRow = PeriodBusinessView['productEconomics'][number];

@Component({
  selector: 'app-product-economics-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './product-economics-card.component.html',
  styleUrl: './product-economics-card.component.css'
})
export class ProductEconomicsCardComponent {
  @Input({ required: true }) product!: ProductEconomicsRow;
  @Input({ required: true }) listingTypeLabel!: string;

  productInitial(): string {
    const title = this.product.itemTitle?.trim() || this.product.itemId?.trim() || 'P';
    return title.charAt(0).toUpperCase();
  }

  productAdsCost(): number {
    return this.product.adCostAmount || 0;
  }

  productFixedCost(): number {
    return this.product.fixedCostAmount || 0;
  }

  productSellerDiscount(): number {
    return this.product.discountSeller || 0;
  }

  productFreightCost(): number {
    const reportFreight = this.product.shippingFeeAmount || 0;
    if (reportFreight > 0) {
      return reportFreight;
    }
    return (this.product.shipmentBaseCost || 0) + (this.product.shipmentOrderCost || 0);
  }

  productMarginClass(): string {
    if (this.product.netResult < 0) return 'negative';
    if ((this.product.marginPct ?? 0) < 12) return 'warning';
    return 'positive';
  }
}
